import PropTypes from 'prop-types';
import React from 'react';

const ListItem = ({ children, className = '', ...props }) => {
	return (
		<>
			<li className={`list-item ${className}`} {...props}>
				{children}
			</li>
		</>
	);
};

ListItem.propTypes = {
	variant: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	className: PropTypes.string,
};

export default ListItem;
